import Base from 'records/Base';
import {
    RECIPE_EXCEL_DOWNLOAD_START,
    RECIPE_EXCEL_DOWNLOAD_ERROR,
    EXCEL_DOWNLOAD_RECIPE_CARD_SUCCESS,
} from 'actions/excel';

const initialState = new Base({
    loading: false,
    errorMessage: null,
});

const actionsMap = {
    [RECIPE_EXCEL_DOWNLOAD_START]: (state) => {
        return state.merge({
            loading: true,
            errorMessage: null,
        });
    },
    [RECIPE_EXCEL_DOWNLOAD_ERROR]: (state, action) => {
        return state.merge({
            loading: false,
            errorMessage: action.error,
        });
    },
    [EXCEL_DOWNLOAD_RECIPE_CARD_SUCCESS]: (state, action) => {
        return state.merge({
            loading: false,
            errorMessage: null,
        });
    },
};

export default function excel(state = initialState, action = {}) {
    const fn = actionsMap[action.type];
    return fn ? fn(state, action) : state;
}